(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    class BackToTop extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.button = this.querySelector('[data-back-to-top]');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.threshold = 420;

      this.onScroll = () => {
        window.clearTimeout(this._scrollTimer);
        this._scrollTimer = window.setTimeout(() => this.syncVisibility(), 40);
      };

      this.onClick = (event) => {
        event.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: this.reduceMotion ? 'auto' : 'smooth',
        });
      };

      this.button?.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.hidden = false;
      this.syncVisibility();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onScroll);
      window.clearTimeout(this._scrollTimer);
    }

    syncVisibility() {
      const show = window.scrollY > this.threshold;
      this.classList.toggle('is-visible', show);
    }
  }

  if (!customElements.get('back-to-top')) {
    customElements.define('back-to-top', BackToTop);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.input = this.querySelector('[data-predictive-search-input]');
      this.resetButton = this.querySelector('[data-predictive-search-reset]');
      this.results = this.querySelector('[data-predictive-search-results]');
      this.status = this.querySelector('[data-predictive-search-status]');
      this.idle = this.querySelector('[data-predictive-search-idle]');
      this.skeleton = this.querySelector('[data-predictive-search-skeleton]');
      this.content = this.querySelector('[data-predictive-search-content]');
      this.endpoint = this.dataset.url;
      this.limit = Number(this.dataset.limit || 6);
      this.cache = new Map();
      this.abortController = null;
      this.debounceTimer = null;

      this.onInput = () => this.onQueryChange();
      this.onReset = () => this.clear();
      this.onKeyDown = (event) => this.handleKeys(event);

      this.input?.addEventListener('input', this.onInput);
      this.input?.addEventListener('keydown', this.onKeyDown);
      this.resetButton?.addEventListener('click', this.onReset);
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.onInput);
      this.input?.removeEventListener('keydown', this.onKeyDown);
      this.resetButton?.removeEventListener('click', this.onReset);
      this.abortController?.abort();
      window.clearTimeout(this.debounceTimer);
    }

    onQueryChange() {
      const term = this.input.value.trim();
      this.resetButton?.classList.toggle('is-hidden', term.length === 0);

      window.clearTimeout(this.debounceTimer);
      if (term.length < 2) {
        this.showIdle();
        return;
      }

      this.debounceTimer = window.setTimeout(() => this.search(term), 220);
    }

    async search(term) {
      const cached = this.cache.get(term);
      if (cached) {
        this.abortController?.abort();
        this.render(cached);
        return;
      }

      this.abortController?.abort();
      const controller = new AbortController();
      this.abortController = controller;
      this.setLoading(true);

      const url = new URL(this.endpoint, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('section_id', 'predictive-search');
      url.searchParams.set('resources[type]', 'product,query,collection');
      url.searchParams.set('resources[limit]', String(this.limit));
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');

      try {
        const response = await fetch(url.toString(), { signal: controller.signal });
        if (!response.ok) throw new Error('Predictive search failed');

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const panel = doc.querySelector('[data-predictive-results]');
        if (!panel) throw new Error('Predictive search section missing');

        const result = { html: panel.outerHTML, status: panel.dataset.status || '' };
        this.cache.set(term, result);
        if (this.input.value.trim() === term) this.render(result);
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error(error);
        this.setLoading(false);
      }
    }

    render({ html, status }) {
      this.setLoading(false);
      if (this.idle) this.idle.hidden = true;

      // Assign from a string so the injected <product-card> elements upgrade and bind.
      this.content.innerHTML = html;
      this.content.hidden = false;

      window.TahReveal?.boot?.(this.content);
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
      if (this.status) this.status.textContent = status;
    }

    setLoading(isLoading) {
      this.classList.toggle('is-loading', isLoading);
      if (!this.skeleton) return;

      if (isLoading) {
        if (this.idle) this.idle.hidden = true;
        // First search shows card placeholders; later searches dim the current results.
        this.skeleton.hidden = !this.content.hidden;
      } else {
        this.skeleton.hidden = true;
      }
    }

    showIdle() {
      this.abortController?.abort();
      this.setLoading(false);
      this.content.innerHTML = '';
      this.content.hidden = true;
      if (this.idle) this.idle.hidden = false;
      if (this.status) this.status.textContent = '';
    }

    handleKeys(event) {
      if (event.key !== 'ArrowDown') return;

      const first = this.content?.querySelector('a[href]:not([tabindex="-1"])');
      if (!first || this.content.hidden) return;

      event.preventDefault();
      first.focus();
    }

    clear() {
      if (this.input) this.input.value = '';
      this.resetButton?.classList.add('is-hidden');
      this.showIdle();
      this.input?.focus();
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class ProductCard extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.hasVariants = this.dataset.hasVariants === 'true';
      this.atcBtns = this.querySelectorAll('[data-add-to-cart]');
      this.atcBtn = this.atcBtns[0];

      this.onAdd = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.hasVariants) {
          this.openQuickAdd();
          return;
        }
        this.addToCart(event.currentTarget);
      };

      this.atcBtns.forEach((btn) => btn.addEventListener('click', this.onAdd));
    }

    disconnectedCallback() {
      this.atcBtns?.forEach((btn) => btn.removeEventListener('click', this.onAdd));
    }

    openQuickAdd() {
      const productUrl = this.dataset.productUrl;
      if (!productUrl) return;

      const popup = document.querySelector('quick-add-popup');
      if (popup && typeof popup.open === 'function') {
        popup.open(productUrl);
        return;
      }

      document.dispatchEvent(
        new CustomEvent('quick-add:open', {
          detail: { productUrl },
        })
      );
    }

    async addToCart(clickedBtn) {
      const trigger = clickedBtn || this.atcBtn;
      if (!trigger || trigger.disabled) return;

      const variantId = this.dataset.variantId;
      const endpoint = this.dataset.cartAddUrl;
      if (!variantId || !endpoint) return;

      const cartDrawer = document.querySelector('cart-drawer');
      const sectionId = cartDrawer?.dataset.sectionId;

      this.atcBtns.forEach((btn) => {
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
      });

      try {
        const payload = {
          items: [{ id: Number(variantId), quantity: 1 }],
        };

        if (sectionId) {
          payload.sections = sectionId;
          payload.sections_url = window.location.pathname;
        }

        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            detail: {
              open: true,
              sections: data.sections,
              itemCount: data.item_count,
              cart: data,
            },
          })
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.atcBtns.forEach((btn) => {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        });
      }
    }
  }

  if (!customElements.get('product-card')) {
    customElements.define('product-card', ProductCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-popup"] && !Shopify.designMode) return;
  try {
    class QuickAddPopup extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.cartAddUrl = this.dataset.cartAddUrl;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.addLabel = this.dataset.addLabel || 'Add to cart';
      this.soldOutLabel = this.dataset.soldOutLabel || 'Sold out';
      this.loadingLabel = this.dataset.loadingLabel || 'Loading…';
      this.errorLabel = this.dataset.errorLabel || 'Unable to load product.';

      this.statusEl = this.querySelector('[data-quick-add-status]');
      this.bodyEl = this.querySelector('[data-quick-add-body]');
      this.imageEl = this.querySelector('[data-quick-add-image]');
      this.vendorEl = this.querySelector('[data-quick-add-vendor]');
      this.titleEl = this.querySelector('[data-quick-add-title]');
      this.priceEl = this.querySelector('[data-quick-add-price]');
      this.compareEl = this.querySelector('[data-quick-add-compare]');
      this.optionsEl = this.querySelector('[data-quick-add-options]');
      this.submitBtn = this.querySelector('[data-quick-add-submit]');
      this.submitLabel = this.querySelector('[data-quick-add-submit-label]');
      this.linkEl = this.querySelector('[data-quick-add-link]');

      this.product = null;
      this.selectedOptions = [];
      this.selectedVariant = null;
      this.lastFocus = null;

      this.onCloseClick = (event) => {
        if (event.target.closest('[data-quick-add-close]')) {
          event.preventDefault();
          this.close();
        }
      };
      this.onKeyDown = (event) => {
        if (event.key === 'Escape' && !this.hidden) this.close();
      };
      this.onOptionClick = (event) => {
        const button = event.target.closest('[data-option-value]');
        if (!button || !this.optionsEl.contains(button)) return;
        const index = Number(button.closest('[data-option-index]')?.dataset.optionIndex);
        if (Number.isNaN(index)) return;
        this.selectedOptions[index] = button.dataset.optionValue;
        this.renderOptions();
        this.syncVariant();
      };
      this.onSubmit = (event) => {
        event.preventDefault();
        this.addToCart();
      };
      this.onOpenEvent = (event) => {
        const url = event.detail?.productUrl;
        if (url) this.open(url);
      };

      this.addEventListener('click', this.onCloseClick);
      this.optionsEl?.addEventListener('click', this.onOptionClick);
      this.submitBtn?.addEventListener('click', this.onSubmit);
      document.addEventListener('keydown', this.onKeyDown);
      document.addEventListener('quick-add:open', this.onOpenEvent);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onCloseClick);
      this.optionsEl?.removeEventListener('click', this.onOptionClick);
      this.submitBtn?.removeEventListener('click', this.onSubmit);
      document.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('quick-add:open', this.onOpenEvent);
      document.body.classList.remove('quick-add-open');
    }

    async open(productUrl) {
      if (!productUrl) return;
      this.lastFocus = document.activeElement;
      this.hidden = false;
      document.body.classList.add('quick-add-open');
      this.showStatus(this.loadingLabel);
      this.bodyEl.hidden = true;
      this.submitBtn.disabled = true;

      try {
        const endpoint = productUrl.includes('.js') ? productUrl : `${productUrl.split('?')[0]}.js`;
        const response = await fetch(endpoint, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Product fetch failed');
        this.product = await response.json();
        this.prepareProduct();
        this.renderProduct();
        this.statusEl.hidden = true;
        this.bodyEl.hidden = false;
        this.querySelector('.quick-add__close')?.focus();
      } catch (error) {
        console.error(error);
        this.showStatus(this.errorLabel, true);
      }
    }

    close() {
      this.hidden = true;
      document.body.classList.remove('quick-add-open');
      this.product = null;
      this.selectedOptions = [];
      this.selectedVariant = null;
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        this.lastFocus.focus();
      }
    }

    showStatus(message, isError = false) {
      this.statusEl.hidden = false;
      this.statusEl.textContent = message;
      this.statusEl.classList.toggle('is-error', Boolean(isError));
    }

    prepareProduct() {
      const variants = this.product.variants || [];
      const firstAvailable = variants.find((variant) => variant.available) || variants[0];
      this.selectedOptions = [
        firstAvailable?.option1 || null,
        firstAvailable?.option2 || null,
        firstAvailable?.option3 || null,
      ].slice(0, (this.product.options || []).length);
    }

    getOptionValues(index) {
      const key = `option${index + 1}`;
      const values = [];
      (this.product.variants || []).forEach((variant) => {
        const value = variant[key];
        if (value && !values.includes(value)) values.push(value);
      });
      return values;
    }

    findVariant(options) {
      return (this.product.variants || []).find((variant) =>
        options.every((value, index) => {
          if (!value) return true;
          return variant[`option${index + 1}`] === value;
        })
      );
    }

    isValueSoldOut(optionIndex, value) {
      const probe = [...this.selectedOptions];
      probe[optionIndex] = value;
      const matches = (this.product.variants || []).filter((variant) =>
        probe.every((selected, index) => {
          if (!selected) return true;
          return variant[`option${index + 1}`] === selected;
        })
      );
      if (!matches.length) return true;
      return matches.every((variant) => !variant.available);
    }

    renderProduct() {
      const image =
        this.product.featured_image ||
        this.product.images?.[0] ||
        '';
      this.imageEl.src = image ? (image.startsWith('//') ? `https:${image}` : image) : '';
      this.imageEl.alt = this.product.title || '';

      if (this.product.vendor) {
        this.vendorEl.hidden = false;
        this.vendorEl.textContent = this.product.vendor;
      } else {
        this.vendorEl.hidden = true;
      }

      this.titleEl.textContent = this.product.title || '';
      this.linkEl.href = `/products/${this.product.handle}`;
      this.renderOptions();
      this.syncVariant();
    }

    renderOptions() {
      const options = this.product.options || [];
      this.optionsEl.innerHTML = options
        .map((name, index) => {
          const selected = this.selectedOptions[index] || '';
          const values = this.getOptionValues(index)
            .map((value) => {
              const soldOut = this.isValueSoldOut(index, value);
              const selectedClass = value === selected ? ' is-selected' : '';
              const soldOutClass = soldOut ? ' is-soldout' : '';
              const soldTag = soldOut
                ? `<span class="quick-add__soldout-tag">${this.escapeHtml(this.soldOutLabel)}</span>`
                : '';
              return `
                <button
                  type="button"
                  class="quick-add__option-btn${selectedClass}${soldOutClass}"
                  data-option-value="${this.escapeHtml(value)}"
                  data-soldout-text="${this.escapeHtml(this.soldOutLabel)}"
                  aria-pressed="${value === selected ? 'true' : 'false'}"
                >
                  ${this.escapeHtml(value)}${soldTag}
                </button>
              `;
            })
            .join('');

          return `
            <fieldset class="quick-add__option" data-option-index="${index}">
              <legend class="quick-add__option-label">
                ${this.escapeHtml(name)}:
                <strong>${this.escapeHtml(selected)}</strong>
              </legend>
              <div class="quick-add__option-values">${values}</div>
            </fieldset>
          `;
        })
        .join('');
    }

    syncVariant() {
      const variant = this.findVariant(this.selectedOptions);
      this.selectedVariant = variant || null;

      if (!variant) {
        this.priceEl.textContent = '';
        this.compareEl.hidden = true;
        this.submitBtn.disabled = true;
        this.submitLabel.textContent = this.soldOutLabel;
        return;
      }

      this.priceEl.textContent = this.formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        this.compareEl.hidden = false;
        this.compareEl.textContent = this.formatMoney(variant.compare_at_price);
      } else {
        this.compareEl.hidden = true;
      }

      const image =
        variant.featured_image?.src ||
        this.product.featured_image ||
        this.product.images?.[0] ||
        '';
      if (image) {
        this.imageEl.src = image.startsWith('//') ? `https:${image}` : image;
      }

      if (variant.available) {
        this.submitBtn.disabled = false;
        this.submitLabel.textContent = this.addLabel;
      } else {
        this.submitBtn.disabled = true;
        this.submitLabel.textContent = this.soldOutLabel;
      }
    }

    async addToCart() {
      if (!this.selectedVariant?.available || !this.cartAddUrl) return;

      const cartDrawer = document.querySelector('cart-drawer');
      const sectionId = cartDrawer?.dataset.sectionId;

      this.submitBtn.classList.add('is-loading');
      this.submitBtn.setAttribute('aria-busy', 'true');

      try {
        const payload = {
          items: [{ id: this.selectedVariant.id, quantity: 1 }],
        };
        if (sectionId) {
          payload.sections = sectionId;
          payload.sections_url = window.location.pathname;
        }

        const response = await fetch(this.cartAddUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        this.close();
        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            detail: {
              open: true,
              sections: data.sections,
              itemCount: data.item_count,
              cart: data,
            },
          })
        );
      } catch (error) {
        console.error(error);
        this.showStatus(error.message || this.errorLabel, true);
        this.bodyEl.hidden = true;
      } finally {
        this.submitBtn.classList.remove('is-loading');
        this.submitBtn.removeAttribute('aria-busy');
      }
    }

    formatMoney(cents) {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(cents, this.moneyFormat);
      }
      const amount = (Number(cents) / 100).toFixed(2);
      return this.moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }
  }

  if (!customElements.get('quick-add-popup')) {
    customElements.define('quick-add-popup', QuickAddPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function markLoaded(host) {
      if (!host || host.classList.contains('is-loaded')) return;
      host.classList.add('is-loaded');
      host.setAttribute('data-skeleton-ready', '');
    }

    function bindSkeleton(host) {
      if (!host || host.dataset.skeletonBound === '1') return;
      host.dataset.skeletonBound = '1';

      if (reduceMotion) {
        markLoaded(host);
        return;
      }

      const media =
        host.querySelector('[data-skeleton-img]') ||
        host.querySelector('img') ||
        host.querySelector('video') ||
        host.querySelector('iframe');

      if (!media) {
        markLoaded(host);
        return;
      }

      const done = () => markLoaded(host);

      if (media.tagName === 'IMG') {
        if (media.complete && media.naturalWidth > 0) {
          done();
          return;
        }
        media.addEventListener('load', done, { once: true });
        media.addEventListener('error', done, { once: true });
      } else if (media.tagName === 'VIDEO') {
        if (media.readyState >= 2) {
          done();
          return;
        }
        media.addEventListener('loadeddata', done, { once: true });
        media.addEventListener('error', done, { once: true });
      } else {
        media.addEventListener('load', done, { once: true });
        media.addEventListener('error', done, { once: true });
      }

      // Safety timeout so skeleton never sticks forever
      window.setTimeout(done, 6000);
    }

    function initSkeletons(root) {
      (root || document).querySelectorAll('[data-skeleton]').forEach(bindSkeleton);
    }

    function initReveal(root) {
      const scope = root || document;
      const items = scope.querySelectorAll('[data-reveal]:not(.is-visible)');

      if (reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach((el) => el.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          root: null,
          rootMargin: '40px 0px -4% 0px',
          threshold: 0.08,
        }
      );

      items.forEach((el, index) => {
        const parent = el.closest('[data-reveal-stagger]');
        if (parent) {
          const siblings = parent.querySelectorAll('[data-reveal]');
          const i = Array.prototype.indexOf.call(siblings, el);
          el.style.setProperty('--reveal-index', String(i >= 0 ? i : index));
        }
        observer.observe(el);
      });

      // Failsafe: never leave content permanently hidden
      window.setTimeout(() => {
        items.forEach((el) => {
          if (!el.classList.contains('is-visible')) {
            el.classList.add('is-visible');
            observer.unobserve(el);
          }
        });
      }, 2800);
    }

    function boot(root) {
      initSkeletons(root);
      initReveal(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
    } else {
      boot(document);
    }

    // Re-bind after Shopify section reloads / AJAX injections
    document.addEventListener('shopify:section:load', (event) => {
      boot(event.target);
    });

    window.TahReveal = { boot, initSkeletons, initReveal, markLoaded };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist"] && !Shopify.designMode) return;
  try {
    const WISHLIST_KEY = 'tah-wishlist';

  function readWishlist() {
    try {
      const raw = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(raw) ? raw : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items } }));
  }

  function itemFromTrigger(trigger) {
    const host = trigger.closest('product-card, tah-product-page, [data-wishlist-item]') || trigger;
    return {
      id: String(trigger.dataset.productId || host.dataset.productId || ''),
      handle: trigger.dataset.productHandle || host.dataset.productHandle || '',
      url: trigger.dataset.productUrl || host.dataset.productUrl || '',
      title: trigger.dataset.productTitle || host.dataset.productTitle || '',
      image: trigger.dataset.productImage || host.dataset.productImage || '',
      price: trigger.dataset.productPrice || host.dataset.productPrice || '',
    };
  }

  class TahWishlist extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      window.TahWishlist = this;
      this.overlay = this.querySelector('[data-wishlist-overlay]');
      this.drawer = this.querySelector('[data-wishlist-drawer]');
      this.bodyEl = this.querySelector('[data-wishlist-body]');
      this.footerEl = this.querySelector('[data-wishlist-footer]');
      this.toastEl = this.querySelector('[data-wishlist-toast]');
      this.headingCount = this.querySelector('[data-wishlist-heading-count]');

      this.onDocClick = (event) => {
        const toggle = event.target.closest('[data-wishlist-toggle]');
        if (toggle) {
          event.preventDefault();
          event.stopPropagation();
          this.toggle(itemFromTrigger(toggle));
          return;
        }

        if (event.target.closest('[data-wishlist-open]')) {
          event.preventDefault();
          this.open();
          return;
        }

        if (event.target.closest('[data-wishlist-close]') || event.target.closest('[data-wishlist-overlay]')) {
          event.preventDefault();
          this.close();
        }
      };

      this.onKey = (event) => {
        if (event.key === 'Escape') this.close();
      };

      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('wishlist:updated', () => this.sync());
      this.sync();
    }

    get items() {
      return readWishlist();
    }

    has(id) {
      return this.items.some((item) => String(item.id) === String(id));
    }

    toggle(item) {
      if (!item || !item.id) return false;
      const items = this.items;
      const index = items.findIndex((entry) => String(entry.id) === String(item.id));
      let added = false;

      if (index >= 0) {
        items.splice(index, 1);
      } else {
        items.unshift(item);
        added = true;
      }

      writeWishlist(items);
      this.showToast(added ? this.dataset.added : this.dataset.removed);
      return added;
    }

    open() {
      this.overlay.hidden = false;
      this.drawer.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.body.classList.add('is-wishlist-open');
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('is-wishlist-open');
      window.setTimeout(() => {
        this.overlay.hidden = true;
        this.drawer.hidden = true;
      }, 380);
    }

    showToast(message) {
      if (!this.toastEl || !message) return;
      this.toastEl.textContent = message;
      this.toastEl.hidden = false;
      window.clearTimeout(this._toastTimer);
      this._toastTimer = window.setTimeout(() => {
        this.toastEl.hidden = true;
      }, 2200);
    }

    sync() {
      const items = this.items;
      const count = items.length;

      document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
        el.textContent = String(count);
        el.classList.toggle('is-hidden', count === 0);
        el.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
      });

      document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
        const item = itemFromTrigger(btn);
        const saved = this.has(item.id);
        btn.classList.toggle('is-active', saved);
        btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
        const label = saved ? this.dataset.removeLabel : this.dataset.addLabel;
        if (label) btn.setAttribute('aria-label', label);
      });

      if (this.headingCount) {
        this.headingCount.hidden = count === 0;
        this.headingCount.textContent = (this.dataset.saved || String(count)).replace(/\d+/, String(count));
      }

      if (this.footerEl) {
        this.footerEl.hidden = count === 0;
      }

      this.renderList(items);
    }

    renderList(items) {
      if (!this.bodyEl) return;

      const heart =
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 21s-6.7-4.35-9.33-8.22C.8 10.2 1.2 6.9 3.7 5.3 6 3.85 8.7 4.6 12 7.4c3.3-2.8 6-3.55 8.3-2.1 2.5 1.6 2.9 4.9 1.03 7.48C18.7 16.65 12 21 12 21Z" fill="currentColor"/></svg>';

      if (!items.length) {
        this.bodyEl.innerHTML =
          '<div class="tah-wishlist__empty">' +
          '<span class="tah-wishlist__empty-mark">' + heart + '</span>' +
          '<p class="tah-wishlist__empty-title">' + this.escape(this.dataset.empty) + '</p>' +
          '<p class="tah-wishlist__empty-hint">' + this.escape(this.dataset.emptyHint) + '</p>' +
          '<button type="button" class="tah-wishlist__continue" data-wishlist-close>' +
          this.escape(this.dataset.continue) +
          '</button></div>';
        return;
      }

      this.bodyEl.innerHTML =
        '<ul class="tah-wishlist__list" role="list">' +
        items
          .map((item) => {
            const image = item.image
              ? '<img src="' + this.escape(item.image) + '" alt="' + this.escape(item.title) + '">'
              : '';
            return (
              '<li class="tah-wishlist__item">' +
              '<a class="tah-wishlist__media" href="' + this.escape(item.url || '#') + '">' + image + '</a>' +
              '<div class="tah-wishlist__details">' +
              '<a class="tah-wishlist__name" href="' + this.escape(item.url || '#') + '">' + this.escape(item.title) + '</a>' +
              (item.price ? '<span class="tah-wishlist__price">' + this.escape(item.price) + '</span>' : '') +
              '<a class="tah-wishlist__view" href="' + this.escape(item.url || '#') + '">' +
              this.escape(this.dataset.view) + ' →</a>' +
              '</div>' +
              '<button type="button" class="tah-wishlist__remove" aria-label="' +
              this.escape(this.dataset.remove) +
              '" data-wishlist-toggle data-product-id="' +
              this.escape(item.id) +
              '">' + heart + '</button>' +
              '</li>'
            );
          })
          .join('') +
        '</ul>';
    }

    escape(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  }

  if (!customElements.get('tah-wishlist')) {
    customElements.define('tah-wishlist', TahWishlist);
  }
  } catch(e) { console.error(e); }
})();

})();
